import React, { useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';


import useWindowSize from '../../utils/useWindowSize';
import { AccountLight, AccountGreen } from '../../Assets';
import { Button } from '../../Atoms';
import {
  getAllUsers,
  resendInvite,
  reset,
} from '../../redux/actions/ManagerAction';
import { connect } from 'react-redux';
import useToaster from '../../components/Toaster/useToaster';
import './team.scss';
import { Loader } from '../../components';
import Pagination from '../../components/Pagination';

const TeamMemberList = ({
  getAllUsers,
  resendInviteDetails: { loading: resendLoading, error, success },
  resendInvite,
  reset,
  allUsers: { loading, list = [] },
}) => {
  const { width } = useWindowSize();
  const { toast } = useToaster();
  const history = useHistory();
  const [currentToken, setCurrentToken] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const classes = classNames('member-table', {
    'table-responsive': width < 678,
  });

  useEffect(() => {
    getAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success) {
      reset('resendInvite');
      toast({
        text: 'Invitation Resend successfully',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const handleClick = (e) => {
    const token = e.target.dataset.value;
    const host = window.location.origin;
    setCurrentToken(token);
    resendInvite({ token: token, invitation_url: `${host}/welcome` });
  };

  const handleRedirect = (e) => {
    const id = e.target.dataset.value;
    history.push(`/team/${id}`);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  if (loading) return <Loader isAbsolute />;

  const paginatedList = list.slice((currentPage - 1) * 10, currentPage * 10);

  return (
    <div className="team-member-list">
      <div className="heading">My Community</div>
      <div className="list-wrapper">
        <div className="table-wrapper">
          <Table className={classes} borderless>
            <thead>
              <tr>
                <th></th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Start Date </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {paginatedList.map((detail, index) => (
                <tr key={index} className="data-row">
                  <td>{detail.id ? <AccountGreen /> : <AccountLight />}</td>
                  <td>{detail.first_name}</td>
                  <td>{detail.last_name}</td>
                  <td>{detail.email}</td>
                  <td>{detail.company_anniversary}</td>
                  <td>
                    {detail.invitation_token && (
                      <Button
                        size="md"
                        color="white"
                        data-value={detail.invitation_token}
                        onClick={handleClick}
                        loading={
                          resendLoading &&
                          currentToken === detail.invitation_token
                        }
                      >
                        Resend Invite
                      </Button>
                    )}
                    {detail.id && !detail.invitation_token && (
                      <Button
                        size="md"
                        color="white"
                        data-value={detail.id}
                        onClick={handleRedirect}
                      >
                        View Profile
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="total-banner mb-3 mb-md-0">
            <span>{list.length}</span>Team Members Invited
          </div>
          <div>
            <Pagination
              activePage={currentPage}
              totalRecords={list.length}
              handleChange={handlePageChange}
              perPage={10}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  resendInviteDetails: state.manager.resendInvite,
  allUsers: state.manager.allUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getAllUsers: () => {
    dispatch(getAllUsers());
  },
  resendInvite: (payload) => {
    dispatch(resendInvite(payload));
  },
  reset: (block) => {
    dispatch(reset(block));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamMemberList);
